import { NavigationState } from '@/types/store/navigation';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const state: NavigationState = {
  documentViewBackRoute: null,
  documentViewBackRouteLabel: null,
  documentViewBackRouteParams: null
};

const namespaced: boolean = true;

export const navigation = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
